import DealsDisclaimer from "./DealsDisclaimer";

export default DealsDisclaimer;
